import React from "react";
import PageShell from "../components/PageShell";
import { BookingCTA, Section } from "../components/MarketingPrimitives";

const ContactUs = () => {
  return (
    <PageShell>
      <Section
        id="contact"
        eyebrow="Contact"
        title="Talk to BestSalesCoach.ai"
        description="If you want to discuss forecast confidence, pipeline quality, founder-led sales, or MEDDICC discipline, book a walkthrough and we will tailor the conversation to your revenue motion."
        tone="hero"
      >
        <div className="contact-card">
          <p className="marketing-body-copy">Email: hello@bestsalescoach.ai</p>
          <div className="hero-actions">
            <BookingCTA
              eventName="book_demo_click"
              sourcePage="contactus"
              ctaClicked="contact_book_20_min_demo"
              requestedOffer="BestSalesCoach.ai Platform Demo"
              buyerType="General"
              urlType="demo"
            />
          </div>
        </div>
      </Section>
    </PageShell>
  );
};

export default ContactUs;
